<template>
  <form-form v-if="initialForm" :initialForm="initialForm" />
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useAbiturientStore } from '@pages/abiturient'
import FormForm from './_Form.vue'

const formStore  = useAbiturientStore()
const initialForm = ref(null)

onMounted(async () => {
  try {
    await formStore.fetchForm()
    initialForm.value = { ...formStore.form }
  } catch (error) {
    console.error(error)
    router.push({ name: 'root' })
  }
})
</script>
